'use strict';
module.exports = Object.create ? Object.create(null) : {};
